import React, { useEffect } from "react"
import { connect } from "react-redux"
import { CardImg, Col, ModalBody, Row } from "reactstrap"
import { getUserMetaTags } from "store/actions"

const ViewContactModal = ({ contact, getUserMetaTags, userMetaTags }) => {
  useEffect(() => {
    getUserMetaTags({ user_id: contact?.id })
  }, [])

  return (
    <ModalBody style={{ overflowX: "hidden", maxHeight: "700px" }}>
      <Row className="my-3 px-3">
        <Col className="align-self-center" style={{ textAlign: "center" }}>
          <CardImg
            src={
              contact?.profile_pic
                ? contact?.profile_pic?.file?.url
                : "https://admin.dev.markedprivate.com/app/images/profile_placeholder.jpg"
            }
            alt="image"
            className="rounded-circle avatar-xl"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <p style={{ color: "#485ec4" }}>
            <b>Admin Use Only</b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Notes:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.notes}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Tags:</b>
          </label>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col className="d-flex flex-wrap">
          {userMetaTags.map(tag => (
            <span
              key={tag?.id}
              style={{
                backgroundColor: "lightgray",
                borderRadius: "15px",
                padding: "7px",
                margin: "3px",
              }}
            >
              {tag?.tag}
            </span>
          ))}
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <p style={{ color: "#485ec4" }}>
            <b>Account Information</b>
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Name:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.full_name}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Email:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.email}</span>
        </Col>
      </Row>
      <Row className="my-3">
        <Col xs={12}>
          <p style={{ color: "#485ec4", margin: "0px" }}>
            <b>Social Profile</b>
          </p>
        </Col>
        <Col>
          <span>
            (Below is how the user completed their social profile on the app to
            be viewed by all)
          </span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Public:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.public ? "YES" : "NO"}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Display Name:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.display_name}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Display Email:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.display_email}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Phone #:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.phone}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Gender:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.gender}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Birthday:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.birthday}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Title/Profession:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.title}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Company:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.company}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Bio:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.bio}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Hobbies:</b>
          </label>
        </Col>
        <Col className="ps-0">
          <span>{contact?.interests}</span>
        </Col>
      </Row>
      <Row>
        <Col xs="auto">
          <label>
            <b>Connect:</b>
          </label>
        </Col>
      </Row>
      <Row>
        <ul className="ms-5">
          <li>
            <label>Facebook: </label>
            <span
              onClick={() => {
                window.open(contact?.fb_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.fb_link}
            </span>
          </li>
          <li>
            <label>Instagram: </label>
            <span
              onClick={() => {
                window.open(contact?.insta_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.insta_link}
            </span>
          </li>
          <li>
            <label>X (Twitter): </label>
            <span
              onClick={() => {
                window.open(contact?.tw_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.tw_link}
            </span>
          </li>
          <li>
            <label> LinkedIn: </label>
            <span
              onClick={() => {
                window.open(contact?.linkedin_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.linkedin_link}
            </span>
          </li>
          <li>
            <label>Pinterest: </label>
            <span
              onClick={() => {
                window.open(contact?.pinterest_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.pinterest_link}
            </span>
          </li>
          <li>
            <label> Youtube: </label>
            <span
              onClick={() => {
                window.open(contact?.yt_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.yt_link}
            </span>
          </li>
          <li>
            <label>TikTok: </label>
            <span
              onClick={() => {
                window.open(contact?.tiktok_link)
              }}
              style={{ cursor: "pointer", color: "-webkit-link" }}
            >
              {" "}
              {contact?.tiktok_link}
            </span>
          </li>
        </ul>
      </Row>
    </ModalBody>
  )
}

const mapStateToProps = state => ({
  userMetaTags: state.people.userMetaTags,
})

const mapDispatchToProps = dispatch => ({
  getUserMetaTags: values => dispatch(getUserMetaTags(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewContactModal)
